import axios from "axios";

export type Zipcode = {
  main: string;
  sub: string;
};
export type Address = {
  address1: string;
  address2: string;
  address3: string;
  kana1?: string;
  kana2?: string;
  kana3?: string;
  prefcode?: string;
  zipcode?: string;
  error?: string;
};

export type Response = {
  config: object;
  data: {
    results: Array<Address>;
  };
  headers: object;
  request: object;
  status: number;
  statusText: string;
};
export type ZipcodeResult = {
  results?: Array<Address>;
  error?: string;
  status?: number;
};

export async function addressSearch(props: string): Promise<ZipcodeResult> {
  const res: Response = await axios.get(
    "https://zipcloud.ibsnet.co.jp/api/search",
    {
      params: {
        zipcode: props,
      },
    },
  );
  if (res.data.results) {
    return {
      results: res.data.results,
      status: res.status,
    };
  } else {
    return {
      error: "住所の取得に失敗しました。",
      status: res.status,
    };
  }
}
